import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const userProfileFormSchema = z.object({
  _id: z.string(),
  id: z.string(),
  email: z.string(),
  address: z.string(),
  creditBalance: z.number(),
  creditHistory: z.array(z.string()),
  deletedAt: z.string().nullable(),
  experienceCount: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  isEmailVerified: z.boolean(),
  phone: z.string(),
  passwordChangeRequired: z.boolean(),
  primarilyDisability: z.string(),
  role: z.string(),
  status: z.string(),
  twoFactorEnabled: z.boolean(),
});

export type UserProfileForm = z.infer<typeof userProfileFormSchema>;

const userProfileFormDefaultValues: UserProfileForm = {
  _id: '',
  id: '',
  email: '',
  address: '',
  creditBalance: 0,
  creditHistory: [],
  deletedAt: '',
  experienceCount: 0,
  firstName: '',
  lastName: '',
  isEmailVerified: false,
  phone: '',
  passwordChangeRequired: false,
  primarilyDisability: '',
  role: '',
  status: '',
  twoFactorEnabled: false,
};

export const useUserProfileForm = () => {
  const form = useForm({
    defaultValues: userProfileFormDefaultValues,
    resolver: zodResolver(userProfileFormSchema),
    reValidateMode: 'onBlur',
  });

  return form;
};
